module.exports = __webpack_public_path__ + "static/media/rainy-6.d235ab65.svg";